const KILOBYTE = 1024;
const MEGABYTE = KILOBYTE * KILOBYTE;

export class ConversorBytes {

    public static bytesToKilobytes(bytes: number): number {
        return bytes / KILOBYTE;
    }

    public static bytesToMegaytes(bytes: number): number {
        return bytes / MEGABYTE;
    }

    public static formatSizeFile(bytes: number): string {
        let size = '';

        if (bytes < KILOBYTE) {
            size = bytes + 'B';
        } else if (bytes > KILOBYTE && bytes < MEGABYTE) {
            size = Math.ceil(bytes / KILOBYTE) + 'KB';
        } else {
            size = Math.ceil(bytes / MEGABYTE) + 'MB';
        }

        return size;
    }
}